var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"image-container"},[_c('el-image',{staticClass:"image-resize",attrs:{"src":this.image}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }